





























































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Gradient } from "@/modules/theme/types";

const Theme = namespace("theme");

@Component({})
export default class BackOfNationalSvg extends Vue {
  @Theme.Getter("getGradient") gradient!: Gradient;
}
